"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SettingCheckbox = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var SettingCheckboxWrap_1 = require("./SettingCheckboxWrap");
function SettingCheckbox(props) {
    var children = props.children, onChange = props.onChange, other = tslib_1.__rest(props, ["children", "onChange"]);
    return (react_1.default.createElement(SettingCheckboxWrap_1.SettingCheckboxWrap, tslib_1.__assign({ onChange: onChange }, other), children));
}
exports.SettingCheckbox = SettingCheckbox;
//# sourceMappingURL=index.js.map